import { render, staticRenderFns } from "./cadservicos.vue?vue&type=template&id=01e16b39&"
import script from "./cadservicos.vue?vue&type=script&lang=js&"
export * from "./cadservicos.vue?vue&type=script&lang=js&"
import style0 from "./cadservicos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports